import "./scripts/ScrollTrigger.min";
import "./scripts/gsap.min";
import "./scripts/sharect";
import "./scripts/jquery.magnific-popup.min";
import "./scripts/unpkg.com_simplebar@6.2.5_dist_simplebar.min";
import "./scripts/jquery.validate.min";
import "./scripts/sticksy.min";

import "./scripts/main";


